"use client"

import { useState, useEffect } from "react"
import { useTranslation } from "@/components/language-provider"
import { getCookieConsent, setCookieConsent } from "@/lib/consent"

export default function CookieConsent() {
  const [show, setShow] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!getCookieConsent()) setShow(true)
  }, [])

  if (!show) return null

  const accept = () => {
    setCookieConsent("accepted")
    setShow(false)
  }

  const decline = () => {
    setCookieConsent("declined")
    setShow(false)
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="beauty-academy-cookie-consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-sm z-50 rounded-2xl border border-border bg-background/95 backdrop-blur-sm p-4 shadow-lg shadow-black/10"
    >
      <p className="text-xs text-muted-foreground leading-relaxed">
        {t("cookie.message")}{" "}
        <a href="/legal/" data-testid="beauty-academy-cookie-consent-learn-more" className="underline hover:text-foreground">
          {t("cookie.learnMore")}
        </a>
      </p>
      <div className="mt-3 flex items-center justify-end gap-1.5">
        <button
          onClick={decline}
          data-testid="beauty-academy-cookie-consent-decline"
          className="px-3 py-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
        >
          {t("cookie.decline")}
        </button>
        <button
          onClick={accept}
          data-testid="beauty-academy-cookie-consent-accept"
          className="px-3 py-1.5 text-xs font-medium bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  )
}
